/**
 * AdBugOfferCard is shown when the guest is on a PDP and that sku has an offer associated with it.
 *
 * @module views/components/AdBugOfferCard
 * @memberof -Common
 */
import './AdBugOfferCard.scss';

import React from 'react';

import PropTypes from 'prop-types';
import { PromoCardCompact } from 'web-palette/dist/components/PromoCardCompact/PromoCardCompact';

import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * Represents a AdBugOfferCard component
 *
 * @method
 * @param {AdBugOfferCard} props - React properties passed from composition
 * @returns AdBugOfferCard
 */
export const AdBugOfferCard = ( props ) => {
  const { image, title, description, expiryInfo, itemClickAction, backgroundColor } = props;

  if( !image && !title && !description && !expiryInfo && !itemClickAction && !backgroundColor ){
    return null;
  }

  const mediaElement = image ? (
    <UltaAsset
      { ...spreadProps( { ...image } ) }
      altText=''
    />
  ) : null;

  return (
    <div className='AdBugOfferCard' role='group' aria-label='offer'>
      <PromoCardCompact
        backgroundColor={ backgroundColor }
        body1={ description }
        disclaimer={ expiryInfo }
        externalMediaElement={ mediaElement }
        fullyClickableParent={ !!itemClickAction }
        externalFullyClickableActionElement={
          itemClickAction ? (
            <Link_Huge action={ itemClickAction } fullyClickableParent={ true }>
              <span className='sr-only'>{ title || 'AdBug Offer' }</span>
            </Link_Huge>
          ) : null
        }
        headline={ title }
        headlineTag='h3'
      />
    </div>
  );
};

/**
 * Property type definitions
 * @typedef AdBugOfferCard
 * @type {object}
 * @property {object} image - Sets the Header image
 * @property {string} title - Sets the title
 * @property {string} description - Sets the description
 * @property {string} expiryInfo - Sets the expiryInfo
 * @property {object} itemClickAction - Sets the actionGroup
 * @property {string} backgroundColor - Sets the background color
 */
export const propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  expiryInfo: PropTypes.string,
  itemClickAction: PropTypes.object,
  backgroundColor: PropTypes.string
};

AdBugOfferCard.propTypes = propTypes;

export default AdBugOfferCard;